const firebaseConfig = {
  apiKey: "AIzaSyB92lowmt1P22IPzYkRB9wbZXlsBvEyrbQ",
  authDomain: "react-urban-riders-authen.firebaseapp.com",
  projectId: "react-urban-riders-authen",
  storageBucket: "react-urban-riders-authen.appspot.com",
  messagingSenderId: "51838973868",
  appId: "1:51838973868:web:0febfb826a07c46e4bac09",
};
export default firebaseConfig;
